<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { isEmpty } from 'lodash'
  import SearchFilter from './SearchFilter'
  import AppPagination from '@/components/ui/AppPagination'
  import UserItem from '@/components/modules/user/UserItem'

  export default {
    name: 'OccasionsPage',
    components: {
      AppPagination,
      UserItem,
      SearchFilter,
    },
    metaInfo() {
      return {
        title: this.$t('meta.occasions.title'),
      }
    },
    data() {
      return {
        page: 1,
        showFilter: false,
        search: '',
      }
    },
    computed: {
      ...mapState('occasions', [
        'occasions',
        'pagination',
        'filterActive',
      ]),
      showResetSearch() {
        return this.$route.query.query || this.search
      },
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page ? value.page : 1

        if (!isEmpty(value.query) && value.query.trim().length > 0 && !this.filterActive) {
          this.search = value.query.trim()
          this.searchOccasions({ page: this.page, query: this.search })
        } else if (this.filterActive) {
          this.filterOccasions({ page: this.page, query: this.search })
        } else {
          this.getOccasions(this.page)
        }
      },
    },
    created() {
      if (this.$route.query.page) {
        this.page = this.$route.query.page
        if (this.$route.query.query) {
          this.search = this.$route.query.query
          return this.searchOccasions({ page: this.page, query: this.search })
        }
        this.getOccasions(this.page)
      } else if (this.$route.query.query) {
        this.search = this.$route.query.query
        this.searchOccasions({ page: this.page, query: this.search })
      } else {
        this.getOccasions(this.page)
      }
    },
    destroyed() {
      this.clearOccasions()
    },
    methods: {
      ...mapActions('occasions', [
        'getOccasions',
        'searchOccasions',
        'filterOccasions',
        'clearOccasions',
        'resetFilter',
        'setFilterActive',
      ]),
      clearSearch() {
        this.search = ''
        if (this.$route.query.query) {
          this.$router.push({ query: { page: 1 } })
        }
      },
      searchPersons(page = 1) {
        if (!isEmpty(this.search) && this.search.trim().length > 0) {
          this.search = this.search.trim()
          if (
            (parseInt(this.$route.query.page) !== parseInt(page) && this.$route.query.query !== this.search) ||
            this.$route.query.query !== this.search ||
            parseInt(this.$route.query.page) !== parseInt(page)
          ) {
            this.$router.push({ query: { page, query: this.search } })
          } else {
            this.searchOccasions({ page, query: this.search })
          }
        }
      },
      filterPersons(page = 1) {
        this.setFilterActive()
        if (
          (parseInt(this.$route.query.page) !== parseInt(page) && this.$route.query.query) ||
          parseInt(this.$route.query.page) !== parseInt(page)
        ) {
          this.$router.push({ query: { page } })
        } else if (
          this.pagination.last < this.pagination.self &&
          parseInt(this.$route.query.page) !== this.pagination.first
        ) {
          this.$router.push({ query: { page: this.pagination.first } })
        } else {
          this.filterOccasions({ page, query: this.search })
        }
      },
      updateOccasions(page = 1) {
        this.getOccasions(page)
      },
    },
  }
</script>
